/**
 * ehr#845: who may add a contact (+ Add Client, Add Referral Source, Add Staff; POST /contacts).
 * One rule for the screen and the API, so the button shows only when the save would be allowed:
 * a role that adds contacts AND the "Create records" right in Access Rights / Role Rights (on for
 * those roles by default; admins hold every right). ehr#905 (Jay): clinicians and supervisors add
 * contacts too, for themselves (naming another owner needs "Share or reassign contacts").
 */
export const CONTACT_CREATE_ROLES = [
    'admin',
    'manager',
    'front_desk',
    'clinician',
    'supervisor',
];
export const CONTACT_CREATE_RIGHT = 'prospect_create';
export function canCreateContacts(role, rights) {
    if (!CONTACT_CREATE_ROLES.includes(role ?? ''))
        return false;
    return rights?.[CONTACT_CREATE_RIGHT] === true;
}
//# sourceMappingURL=contactCreate.js.map